import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../components/sidebar";
import Projects from "../../../components/projects";
import Users from "../../../components/users";
import Profile from "../../../components/profile";
import KanbanBoard from "../../../components/kanban_board";
import Settings from "../../../components/settings";
import Dashboard from "../../../components/dashboard";
import ContasWilder from "../../projects_t_engineering/ContasWilder/ContasWilder";
import InternRegisterUser from '../../inter_register_user';
import UserIntern from "../../../pages/user_intern";

import { appStatus } from "../../../store/modules/app_status/actions";
import { goToGuardianHub } from "../../../utils/appNavigation";

import { currentUrl } from "../../../constants/global";
import { userRequestService } from '../../../services/userRequestService'; // Importe o serviço
import {
  MainContainer,
  BackgroundPattern,
  SideContainer,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  ButtonGrid,
  ButtonContainer,
  ButtonContainerLeft,
  ButtonContainerRight,
  StyledButton,
} from "./styles";
import UserResquestTable from "./UserRequestTable/UserRequestTable";

const GuardianUser = () => {
  const navigate = useNavigate();
  const collapsed = useSelector((state) => state.sidebar);
  const app_status = useSelector((state) => state.app_status.status);
  const location = useLocation();
  const dispatch = useDispatch();
  const user = location?.state?.user;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCancel = () => {
    goToGuardianHub(dispatch, navigate);
  };

  // Função para recarregar os usuários
  const handleUserUpdate = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);

        console.log('Buscando usuários via serviço...'); // Debug

        // Use o serviço em vez do axios diretamente
        const response = await userRequestService.getUserRequests();

        console.log('Resposta do serviço:', response); // Debug

        if (response && response.success) {
          setUsers(response.data || []);
        } else {
          setUsers([]);
        }

      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        console.error("Status do erro:", error.response?.status); // Debug
        console.error("Dados do erro:", error.response?.data); // Debug
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [app_status, refreshTrigger]);

 const handleNewUser = () => {
  dispatch(appStatus("cad_new_user"));
  navigate("/welcome", { 
    state: { userType: "GUARDIAN" } 
  });
}


  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer>
        {
          app_status === 'Projetos' ? <Projects /> :
            app_status === 'Usuários' ? <Users /> :
              app_status === 'Meu Perfil' ? <Profile /> :
                app_status === "Desenvolvimento" ? <KanbanBoard /> :
                  app_status === "Configurações" ? <Settings /> :
                    app_status === "cad_new_user" ? <InternRegisterUser userType={location.state?.userType}/> :
                      app_status === "edit_user" ? <UserIntern user={user} /> :
                        app_status === "Dashboard" ? <Dashboard /> :
                          app_status === "Contas" ? <ContasWilder /> :
                            (
                              <ContentWrapper>
                                <ButtonContainer>
                                  <ButtonContainerLeft>
                                    <StyledButton onClick={handleCancel}>Voltar</StyledButton>
                                  </ButtonContainerLeft>
                                  <ButtonContainerRight>
                                    <StyledButton onClick={handleNewUser}>Adicionar Usuário</StyledButton>
                                  </ButtonContainerRight>
                                </ButtonContainer>

                                <HeaderSection>
                                  <Title>Solicitações de usuário</Title>
                                  <Subtitle>Gerencie, visualize e adicione novos usuário do app guardian</Subtitle>
                                </HeaderSection>



                                {loading ? (
                                  <div>Carregando usuários...</div>
                                ) : (
                                  <UserResquestTable
                                    filteredUsers={users}
                                    onUserUpdate={handleUserUpdate} // Passe a função de callback
                                  />
                                )}
                              </ContentWrapper>
                            )}
      </SideContainer>
    </MainContainer >
  );
};

export default GuardianUser;